
import ReactGA from "react-ga4";
ReactGA.initialize('G-GWQ9QB381K')

//Need to update axios interceptor to log each request time
export const setAxiosTimer = () => {
    
}

export const addUID = (player_id) => {
    //analytics.addCustomDimension(player_id, 'uid')
}

export const pageHit = async(path:string, pageName:String, player_id?:string) => {
    try {
        await ReactGA.send({ hitType: "pageview", page:path, title:pageName, userId: player_id });
    } catch(e) {
        console.log(e)
    }
}


export const logEvent = async(category, action, label, value) => {
    try {
        //await analytics.event(new Event(category, action, label, value))
    } catch (e) {
        console.log(e)
    }
}